import { ApiFactory } from '@/api/api-factory';

const campaignsClient = ApiFactory.getCampaignsClient();

export default {
  async getCampaignResults({ commit, dispatch }, sfvs) {
    dispatch('common/showBusyCursor', 'Fetching Results ...', { root: true });
    try {
      const campaignResults = await campaignsClient.fetchCampaignResults(sfvs);
      commit('setCampaignResults', campaignResults);
      commit('setCampaignResultsLoaded', true);
      dispatch('common/hideBusyCursor', null, { root: true });
    } catch (err) {
      console.error(err);
    } finally {
      dispatch('common/hideBusyCursor', null, { root: true });
    }
  },
};
